export default {
  preferences: {
    title: "Preferences",
    promo: {
      blurb: "Advanced plays.\nDeeper insights.",
    },
    sections: {
      account: "Account",
      display: "Display",
      support: "Support",
      about: "About",
    },
    items: {
      profile: "Profile",
      location: "Location",
      manageSubscription: "Manage Subscription",
      glossary: "Glossary",
      contactSupport: "Contact Support",
      logOut: "Log Out",
      deleteAccount: "Delete Account",
    },
    profile: {
      title: "Profile",
      alerts: {
        passwordMessage: "To change password, visit linemate.io",
        usernameInvalid: "Your username needs to be at least 6 characters. It should only include letters and numbers.",
        usernameTaken: "Username is already taken",
      },
      saved: "Profile saved",
    },
    display: {
      preferences: {
        theme: "Theme",
        odds: "Odds",
        language: "Language",
      },
      options: {
        theme: {
          "Match System": "Match System",
          Light: "Light",
          Dark: "Dark",
        },
        odds: {
          american: "American",
          decimal: "Decimal",
        },
      },
    },
    language: {
      loading: "Updating language...",
    },
    about: {
      terms: "Terms",
      privacy: "Privacy",
      responsibleGambling: "Responsible Gambling",
      openSourceLibraries: "Open Source Libraries",
      acknowledgments: "Acknowledgments",
    },
    subscription: {
      alertTitle: "Subscription",
      webMessage: "To manage your subscription please visit the profile section at linemate.io",
      googlePlayMessage: "To manage your subscription please visit the Subscriptions section of your Google Play Store account associated with this purchase",
      appleMessage: "To manage your subscription please visit the Subscriptions section of your Apple account associated with this purchase",
      manageTitle: "Manage subscription",
      currentPlan: "Current plan",
      changePlan: "Change plan",
      cancelPlan: "Cancel subscription",
      cancelTitle: "Cancel subscription",
      cancelHeading: "Why are you cancelling?",
      cancelSubtitle: "Your feedback will help us improve our product.",
      missingTitle: "What's missing?",
      missingSubtitle: "What features or tools would make Linemate more valuable for you?",
      improveTitle: "Let us know how to improve",
      improveSubtitle: "Your feedback helps us make things better.",
      trialActive: "Your Linemate+ trial is still active.",
      alreadyActive: "You already have access to Linemate+",
      exclusiveOfferFallbackTitle: "Exclusive offer",
      exclusiveOfferFallbackSubtitle: "Keep your access with a limited-time offer before you cancel.",
      claimOneTimeOffer: "Claim one-time offer",
      offerApplyFailure: "We were unable to apply this offer right now. Please try again later.",
      continueToCancel: "Continue to cancel",
      losingAccessTitle: "You'll be losing access to our latest advanced features",
      losingAccessSubtitle: "Here's what you're going to lose when your plan ends.",
      keepSubscription: "Keep subscription",
      feedbackPlaceholder: "Enter your answer...",
    },
    providers: {
      locationTitle: "Allow Linemate to access your location to set your preferred odds",
      locationSubtitle: "Linemate uses your location to show providers in your area",
    },
    location: {
      title: "Location",
      useCurrentLocation: "Use current location",
      enableLocationMessage: "Save time and allow location sharing so we can show you the best markets and offers.",
    },
    logout: {
      title: "Log Out",
      message: "Are you sure you want to log out?",
    },
    deleteAccount: {
      warningTitle: "Warning",
      warningMessage: "You currently have an active subscription, you will have to cancel it before deleting your account.",
      confirmTitle: "Delete Account",
      confirmMessage: "Are you sure you want to delete your account?",
      confirmAction: "Delete",
      successTitle: "Delete Account",
      successMessage: "Your account has successfully been deleted.",
      errorTitle: "Error",
    },
    communication: {
      title: "Communication",
      email: "Email",
      emailDescription: "Marketing emails, research updates, product news, and occasional platform announcements.",
      notificationSettings: "Notification settings",
      notificationDescription: "Marketing notifications, reminders before key game windows and updates about new features.",
    },
    feedback: {
      title: "Share feedback",
      enjoymentPrompt: "Are you enjoying your experience?",
      improvePrompt: "Tell us how we can improve. Every bit of feedback helps.",
      actions: {
        yes: "Yes",
        no: "No",
        contactUs: "Contact us",
        notNow: "Not now",
      },
      communication: {
        title: "Communication",
        email: "Email",
        emailDescription: "Marketing emails, research updates, product news, and occasional platform announcements.",
        notificationSettings: "Notification settings",
        notificationDescription: "Marketing notifications, reminders before key game windows and updates about new features.",
      },
    },
  },
};
